import { IFlightTypeState, actionTypes } from 'src/ducks/flight-type.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getFlightTypeStatus = (
  state: IFlightTypeState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
